/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { CustomArrowProps } from 'react-slick';
import ArrowBack from '@material-ui/icons/ChevronLeft';
import ArrowForward from '@material-ui/icons/ChevronRight';

export const SlickForwardButton = ({ currentSlide, slideCount, ...props }: CustomArrowProps) => <ArrowForward {...props} />;

export const SlickBackButton = ({ currentSlide, slideCount, ...props }: CustomArrowProps) => <ArrowBack {...props} />;
